import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';
import Link from '../../../components/link';
import Image from '../../../components/image';

const SignUpBanner = () => {

  const bannerQuery = useStaticQuery(graphql`
  query {
    wp {
      themeOptions {
        acfThemeOptions {
          footerBanner {
            title
            text
            image {
              mimeType
              altText
              localFile {
                publicURL
                childCloudinaryAsset {
                  gatsbyImageData
                }
              }
            }
            buttons {
              button {
                target
                url
                title
              }
            }
          }
        }
      }
    }
  }
`);

  const content = bannerQuery.wp.themeOptions.acfThemeOptions.footerBanner;
  return (
    <section className='CTA__banner'>
      <div className="Container">
        <div className="CTA__banner__wrap">
          <div className="CTA__banner__content col-4">
            <h2>{content.title}</h2>
            <p>{content.text}</p>
            {content.buttons.map((button, i) => (
              <Link className={`Button Button__secondary${i !== 0 ? '--outline' : ''}`} key={i} to={button.button.url}>{button.button.title}</Link>
            ))}
          </div>
          <div className="CTA__banner__image">
              <Image source={content.image} imgClass={"CTA__banner__image__img"}/>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SignUpBanner

